import * as React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { DOCUMENT_ZOOM_STEP, DOCUMENT_DATA_DPI } from '../../_config/Consts';
import Dimensions from '../../Utils/Dimensions';
import { ZoomIn, ZoomOut } from '@mui/icons-material';

export type Props = ButtonProps & {
	type:string
	onZoom?: Function
	documentDPI?: number
	documentWidth?: number
	documentHeight?: number
	viewerWidth?: number
	viewerHeight?: number
}

export default class ZoomButton extends React.Component<Props> {
	private getZoom = (dir:string) => {
		let zoom = (DOCUMENT_ZOOM_STEP / 100 * DOCUMENT_DATA_DPI) / this.props.documentDPI * DOCUMENT_DATA_DPI;
		if(dir == "out") zoom *= -1;
		return zoom / (DOCUMENT_DATA_DPI / Dimensions.getMaxDPI(this.props.documentWidth, this.props.documentHeight));
	}

	render = () => {
		let {type, onZoom, documentDPI, documentWidth, documentHeight, viewerWidth, viewerHeight, ...rest} = this.props;
		return <Button color="secondary" {...rest}
			onClick={(e) => onZoom(this.getZoom(type), viewerWidth/2, viewerHeight/2)}
		>
			{type == "in" ? <ZoomIn /> : type == "out" ? <ZoomOut /> : <></>}
		</Button>
	}
}